import { LocalFirstVisitCase } from './local-first-visit-case.enum';
import { RemoteFirstVisitCase } from './remote-first-visit-case.enum';

export const FirstVisitCase = {
  ...LocalFirstVisitCase,
  ...RemoteFirstVisitCase,
};

export type FirstVisitCase = LocalFirstVisitCase | RemoteFirstVisitCase;
